'use client'
import { usePathname } from 'next/navigation'
import { BulletproofCartProvider } from '@/hooks/useBulletproofCart'
import { ThemeProvider } from '@/components/public/branding/ThemeProvider'

interface CartProvidersProps {
  children: React.ReactNode
}

// ThemeProvider provides branding data context (no CSS side effects).
// DynamicStyles injects global CSS and is loaded in the PUBLIC layout
// only — it must NOT be here at the root level or it leaks :root CSS
// variables into admin/boxoffice pages.
//
// The door scanner (/scanner) uses neither: it has no cart and its own
// fixed colours. Loading them there cost a cart and a branding request on
// every open, and both logged "Failed to fetch" errors whenever the venue
// wifi dropped.
export function CartProviders({ children }: CartProvidersProps) {
  const pathname = usePathname()
  if (pathname === '/scanner' || pathname?.startsWith('/scanner/')) return <>{children}</>
  return (
    <ThemeProvider>
      <BulletproofCartProvider>
        {children}
      </BulletproofCartProvider>
    </ThemeProvider>
  )
}
